export function commaNumber(
  value: string | number | undefined,
  option?: Intl.NumberFormatOptions
) {
  return Number(value).toLocaleString('en-US', {
    maximumFractionDigits: 20,
    ...option
  })
}
